import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

import { SessionStorageService } from 'ngx-webstorage';

import { AppRoutes } from '@rx-applications/clientsite/shared/router/data-access';
import { SessionKeys } from '@core/modules/error/models';


@Injectable({ providedIn: 'root' })
export class ErrorService {
  // Because the ErrorHandler is created before the providers, we’ll have to use the Injector to get them.
  constructor(private injector: Injector, private sessionStorageService: SessionStorageService) {}

  private readonly chunkFailedMessage = /Loading chunk [\d]+ failed/;

  handleError(error: Error | HttpErrorResponse) {
    const router = this.injector.get(Router);
    if (this.chunkFailedMessage.test(error.message)) {
      this.handleChunkLoadingFailed(error, router);
      return;
    }

    // Http Errors are handled in an interceptor
    if (!(error instanceof HttpErrorResponse)) {
      router.navigate([AppRoutes.Error500]);
    }

    this.logError(error);
  }

  handleChunkLoadingFailed(error: Error | HttpErrorResponse, router: Router): void {
    if (!this.sessionStorageService.retrieve(SessionKeys.HaveTriedToReload)) {
      this.logError(`Chunk Loading Handler Reloading Page: ${error}`);
      this.sessionStorageService.store(SessionKeys.HaveTriedToReload, true);
      window.location.reload();
    } else {
      this.logError(`Chunk Loading Handler Failed: ${error}`);
      this.sessionStorageService.store(SessionKeys.HaveTriedToReload, false);
      router.navigate([AppRoutes.Error500]);
    }
  }

  logError(error: string | Error | HttpErrorResponse) {
    console.error(error); // eslint-disable-line no-console
  }
}
